import { canv } from '@/canv/global.js'

export class shapePredefinedProcess {

    constructor() {

    }


    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width * 3/5 - 2 * horizontalPadding;
        var allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y);
        canv.ctx.lineTo(x + width, y);
        canv.ctx.lineTo(x + width, y + height);
        canv.ctx.lineTo(x, y + height);
        canv.ctx.lineTo(x, y);

        // второй слой
        canv.ctx.lineTo(x, y + height/2);

        canv.ctx.moveTo(x + width/5, y);
        canv.ctx.lineTo(x + width/5, y + height);

        canv.ctx.moveTo(x + width * 4/5, y);
        canv.ctx.lineTo(x + width * 4/5, y + height);
        canv.ctx.closePath();
    }

    getAvatar(color) {
        return `
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="79" height="79" rx="4.5" fill="` + color + `" stroke="black"/>
        <line x1="63.5" x2="63.5" y2="79" stroke="black"/>
        <line x1="16.5" x2="16.5" y2="79" stroke="black"/>
        </svg>

        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="24" height="24" rx="1.5" fill="` + fill + `" stroke="black"/>
                <line x1="20.1875" x2="20.1875" y2="24.6875" stroke="black"/>
                <line x1="5.5" x2="5.5" y2="24.6875" stroke="black"/>
            </svg>
        `;
    }

}
